import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroupManager from "./routes/YearGroupManager";

export default store => ({
  path: "year-group-manager",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "year-group-manager" */ "./components/YearGroupManagerWrapper"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [YearGroupManager(store)],
});
